<script>
import AutomationActionTeamMessageInput from './AutomationActionTeamMessageInput.vue';
import AutomationActionFileInput from './AutomationFileInput.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

// Zimobi imports
import AutomationCreateDeal from './atendeTotal/AutomationCreateDeal.vue';
import AutomationCreateDealWithVariables from './atendeTotal/AutomationCreateDealWithVariables.vue';
import AutomationAttachLabelToDeal from './atendeTotal/AutomationAttachLabelToDeal.vue';
import AutomationSendWhatsappTemplate from './atendeTotal/AutomationSendWhatsappTemplate.vue';
import AutomationUpdateCustomAttribute from './atendeTotal/AutomationUpdateCustomAttribute.vue';
import AutomationActionPortalLeadDistribution from './atendeTotal/AutomationActionPortalLeadDistribution.vue';
import { defineAsyncComponent } from 'vue';

const AutomationActionIfElse = defineAsyncComponent(
  () => import('custom/dashboard/components/widgets/AutomationActionIfElse.vue')
);
// Zimobi imports

export default {
  components: {
    AutomationActionTeamMessageInput,
    AutomationActionFileInput,
    WootMessageEditor,
    NextButton,
    AutomationCreateDeal,
    AutomationCreateDealWithVariables,
    AutomationAttachLabelToDeal,
    AutomationSendWhatsappTemplate,
    AutomationUpdateCustomAttribute,
    AutomationActionPortalLeadDistribution,
    AutomationActionIfElse,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
    actionTypes: {
      type: Array,
      default: () => [],
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    errorMessage: {
      type: String,
      default: '',
    },
    showActionInput: {
      type: Boolean,
      default: true,
    },
    initialFileName: {
      type: String,
      default: '',
    },
    isMacro: {
      type: Boolean,
      default: false,
    },
    automationEventName: {
      type: String,
      default: '',
    },
    automationTypes: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue', 'input', 'removeAction', 'resetAction'],
  computed: {
    action_value: {
      get() {
        if (!this.value) return null;
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    action_name: {
      get() {
        if (!this.modelValue) return null;
        return this.modelValue.action_name;
      },
      set(value) {
        const payload = this.modelValue || {};
        this.$emit('update:modelValue', { ...payload, action_name: value });
        this.$emit('input', { ...payload, action_name: value });
      },
    },
    action_params: {
      get() {
        if (!this.modelValue) return null;
        return this.modelValue.action_params;
      },
      set(value) {
        const payload = this.modelValue || {};
        this.$emit('update:modelValue', { ...payload, action_params: value });
        this.$emit('input', { ...payload, action_params: value });
      },
    },
    inputType() {
      const actionType = this.actionTypes.find(
        action => action.key === this.action_name
      );
      return actionType ? actionType.inputType : null;
    },
    actionInputStyles() {
      return {
        'has-error': this.errorMessage,
        'is-a-macro': this.isMacro,
      };
    },
    castMessageVmodel: {
      get() {
        if (!this.action_params) return null;
        if (Array.isArray(this.action_params)) {
          return this.action_params[0];
        }
        return this.action_params;
      },
      set(value) {
        this.action_params = value;
      },
    },
    isCreateOpportunityInPiperun() {
      return this.action_name === 'create_opportunity_in_piperun';
    },
    createDealAutomationDealNameInputPlaceholder() {
      return this.isCreateOpportunityInPiperun
        ? 'Nome da oportunidade'
        : undefined;
    },
  },
  methods: {
    removeAction() {
      this.$emit('removeAction');
    },
    resetAction() {
      this.$emit('resetAction');
    },
  },
};
</script>

<template>
  <div class="filter" :class="actionInputStyles">
    <div class="filter-inputs">
      <select
        v-model="action_name"
        class="action__question"
        :class="{ 'full-width': !showActionInput }"
        @change="resetAction()"
      >
        <option
          v-for="attribute in actionTypes"
          :key="attribute.key"
          :value="attribute.key"
        >
          {{ attribute.label }}
        </option>
      </select>
      <div v-if="showActionInput" class="filter__answer--wrap">
        <div v-if="inputType" class="w-full">
          <div
            v-if="inputType === 'search_select'"
            class="multiselect-wrap--small"
          >
            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
            >
              <template #noOptions>
                {{ $t('FORMS.MULTISELECT.NO_OPTIONS') }}
              </template>
            </multiselect>
          </div>
          <div
            v-else-if="inputType === 'multi_select'"
            class="multiselect-wrap--small"
          >
            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              multiple
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
            >
              <template #noOptions>
                {{ $t('FORMS.MULTISELECT.NO_OPTIONS') }}
              </template>
            </multiselect>
          </div>
          <input
            v-else-if="inputType === 'email'"
            v-model="action_params"
            type="email"
            class="answer--text-input"
            :placeholder="$t('AUTOMATION.ACTION.EMAIL_INPUT_PLACEHOLDER')"
          />
          <input
            v-else-if="inputType === 'url'"
            v-model="action_params"
            type="url"
            class="answer--text-input"
            :placeholder="$t('AUTOMATION.ACTION.URL_INPUT_PLACEHOLDER')"
          />
          <input
            v-else-if="inputType === 'text'"
            v-model="action_params"
            type="text"
            class="answer--text-input"
            :placeholder="$t('AUTOMATION.ACTION.TEXT_INPUT_PLACEHOLDER')"
          />
          <AutomationActionFileInput
            v-if="inputType === 'attachment'"
            v-model="action_params"
            :initial-file-name="initialFileName"
          />
        </div>
      </div>
      <NextButton
        v-if="!isMacro"
        icon="i-lucide-x"
        slate
        ghost
        class="flex-shrink-0"
        @click="removeAction"
      />
    </div>
    <AutomationActionTeamMessageInput
      v-if="inputType === 'team_message'"
      v-model="action_params"
      :teams="dropdownValues"
    />
    <!--
      Zimobi: `add_private_note` arrived with Chatwoot 4.4.0 declaring `inputType: 'textarea'`,
      but no branch here matches it and there is no generic textarea fallback, so picking the
      action left the agent with nowhere to type the note. It reads the same editor as
      `send_message`: both end up in Messages::MessageBuilder, and Message runs the content
      through Liquid on create (`Liquidable#process_liquid_in_content`), so the variable picker
      is honoured for both.
    -->
    <WootMessageEditor
      v-if="
        inputType === 'textarea' &&
        ['send_message', 'add_private_note'].includes(action_name)
      "
      v-model="castMessageVmodel"
      rows="4"
      enable-variables
      :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
      class="action-message"
    />
    <AutomationCreateDeal
      v-if="
        inputType === 'textarea' &&
        [
          'create_deal_in_vista_if_customer_exists',
          'create_opportunity_in_piperun',
          'create_deal_in_properfy',
        ].includes(action_name)
      "
      v-model="action_params"
      :deal-name-input-placeholder="
        createDealAutomationDealNameInputPlaceholder
      "
    />
    <AutomationCreateDealWithVariables
      v-if="inputType === 'textarea' && action_name === 'create_deal'"
      v-model="action_params"
    />
    <AutomationAttachLabelToDeal
      v-if="
        inputType === 'textarea' &&
        action_name === 'attach_label_to_deal_in_pipefy'
      "
      v-model="action_params"
    />
    <AutomationUpdateCustomAttribute
      v-if="
        inputType === 'textarea' && action_name === 'update_custom_attribute'
      "
      v-model="action_params"
    />
    <AutomationSendWhatsappTemplate
      v-if="
        inputType === null && action_name === 'send_whatsapp_template_message'
      "
      v-model="action_params"
    />
    <AutomationActionPortalLeadDistribution
      v-if="inputType === null && action_name === 'portal_lead_distribution'"
      v-model="action_params"
    />
    <AutomationActionIfElse
      v-if="inputType === null && action_name === 'if_else'"
      v-model="action_params"
      :automation-event-name="automationEventName"
      :automation-action-types="actionTypes"
      :automation-types="automationTypes"
    />

    <p v-if="errorMessage" class="filter-error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.filter {
  @apply bg-n-background p-2 border border-solid border-n-strong dark:border-n-strong rounded-lg mb-2;

  &.is-a-macro {
    @apply mb-0 bg-n-background dark:bg-n-solid-1 p-0 border-0 rounded-none;
  }
}

.no-margin-bottom {
  @apply mb-0;
}

.filter.has-error {
  @apply bg-n-ruby-8/20 border-n-ruby-5 dark:border-n-ruby-5;

  &.is-a-macro {
    @apply bg-transparent;
  }
}

.filter-inputs {
  @apply flex gap-1;
}

.filter-error {
  @apply text-n-ruby-9 dark:text-n-ruby-9 block my-1 mx-0;
}

.action__question,
.filter__operator {
  @apply mb-0 mr-1;
}

.action__question {
  @apply max-w-[50%];
}

.action__question.full-width {
  @apply max-w-full;
}

.filter__answer--wrap {
  @apply max-w-[50%] flex-grow mr-1 flex w-full items-center justify-start;

  input {
    @apply mb-0;
  }
}
.filter__answer {
  &.answer--text-input {
    @apply mb-0;
  }
}

.filter__join-operator-wrap {
  @apply relative z-20 m-0;
}

.filter__join-operator {
  @apply flex items-center justify-center relative my-2.5 mx-0;

  .operator__line {
    @apply absolute w-full border-b border-solid border-n-weak;
  }

  .operator__select {
    margin-bottom: 0 !important;
    @apply relative w-auto;
  }
}

.multiselect {
  @apply mb-0;
}
.action-message {
  @apply mt-2 mx-0 mb-0;
}
// Prosemirror does not have a native way of hiding the menu bar, hence
::v-deep .ProseMirror-menubar {
  @apply hidden;
}
</style>
